export default function () {
  controller('datapicker-range', self => {
    var from = $(".js-artist-from")
      .datepicker({
        dateFormat: "yy/mm/dd",
        numberOfMonths: 1,
        showOn: "both",
        buttonImage: "assets/img/icon-calendar.svg",
        buttonImageOnly: true,
        changeMonth: true,
        changeYear: true,
        afterShow: renderDrop
      })
      .on("change", function () {
        to.datepicker("option", "minDate", getDate(this));
      });
    
    var to = $(".js-artist-to").datepicker({      
      dateFormat: "yy/mm/dd",
      numberOfMonths: 1,
      showOn: "both",
      buttonImage: "assets/img/icon-calendar.svg",
      buttonImageOnly: true,
      changeMonth: true,
      changeYear: true,
      afterShow: renderDrop
    })
      .on("change", function () {
        from.datepicker("option", "maxDate", getDate(this));
      });

    function getDate(element) {
      var date;
      try {
        date = $.datepicker.parseDate(element.value);
      } catch (error) {
        date = null;
      }

      return date;
    }

    function renderDrop() {
      var _dropdown;
      var settings = {autoReinitialise: true};
      $('.ui-datepicker-month, .ui-datepicker-year').styler({
        selectSearch: false,
        onFormStyled: function () {
          _dropdown = $('.jq-selectbox__dropdown');
          _dropdown.find('ul').wrap('<div class="scroll-pane" ></div>');
        },
        onSelectOpened: function () {
          var _ul = $(this).find('.jq-selectbox__dropdown ul');
          var height = _ul.height();
          var _srollPane = _dropdown.find('.scroll-pane');
          _srollPane.height(height);
          _ul.css('max-height', 'none');
          _srollPane.jScrollPane(settings);
        }
      });
    }
  });
}
